import CodeToNationality from '@master/config/nationality-code-to-label.json'
import CodeToCountry from '@master/config/country-code-to-label.json'
import LabelToCodeCountry from '@master/config/country-label-to-code.json'
import LabelToCodeNationality from '@master/config/nationality-label-to-code.json'
import { options } from './Options'

export const CountryOptions: options[] = Object.keys(CodeToCountry).map(key => {
  return {
    label: CodeToCountry[key],
    value: key
  }
}).sort((a, b) => {
  if (a.value === 'SG') {
    return -1
  } else if (b.value === 'SG') {
    return 1
  } else if (a.value === 'MY') {
    return -1
  } else if (b.value === 'MY') {
    return 1
  } else {
    return a.label.localeCompare(b.label)
  }
}) // sort by Singapore, Malaysia, and the rest of countries

export const NationalityOptions: options[] = Object.keys(CodeToNationality).map(key => {
  return {
    label: CodeToNationality[key],
    value: key
  }
}).sort((a, b) => {
  if (a.value === 'SG') {
    return -1
  } else if (b.value === 'SG') {
    return 1
  } else if (a.value === 'MY') {
    return -1
  } else if (b.value === 'MY') {
    return 1
  } else {
    return a.label.localeCompare(b.label)
  }
}) // sort by Singapore, Malaysia, and the rest of nationalities

export const CountryLabelToCode = LabelToCodeCountry
export const NationalityLabelToCode = LabelToCodeNationality
